import { Injectable, signal } from "@angular/core";

@Injectable({
    providedIn: "root",
})
export class StateService {
    private isToolbarActive = signal(true);

    constructor() {}

    get showToolbar(): boolean {
        return this.isToolbarActive();
    }

    set showToolbar(value: boolean) {
        console.log("Setting showToolbar to", value);

        this.isToolbarActive.set(value);
    }
}
